import React from 'react'

export const VALUED_CELL_MONEY_TYPE = 'money'
export const VALUED_CELL_PERCENTAGE_TYPE = 'percentage'

/**
 * Valued Cell component.
 * @param {Object} props
 * @param {String | Number} props.value // Cell value
 * @param {String} props.type // Type of cell
 * @returns {JSX.Element}
 */
const ValuedCell = ({ value, type }) => {
  if (!value || value === Infinity || typeof value !== 'number') {
    return <span>&mdash;</span>
  }

  if (type === VALUED_CELL_MONEY_TYPE) {
    return <span>${value.toFixed(2)}</span>
  }

  if (type === VALUED_CELL_PERCENTAGE_TYPE) {
    return <span>{value.toFixed(2)}%</span>
  }

  return <span>{value}</span>
}

export default ValuedCell
